import {
  Button,
  ButtonRole,
  ButtonSize,
  ButtonTargetKind,
} from "@components/Button";
import { Card } from "@components/Card";
import styled from "@emotion/styled";

import {
  getRoutePath,
  ClientRouteName,
  URLFormat,
} from "@every.org/common/src/helpers/clientRoutes";

import { ContextNonprofit } from "src/context/NonprofitsContext/types";
import { verticalStackCss } from "src/theme/spacing";
import { textSizeCss } from "src/theme/text";

const StyledCard = styled(Card)`
  ${verticalStackCss.l};
  max-width: 688px;
`;

interface FundAccountCardProps {
  nonprofit: ContextNonprofit;
  className?: string;
}
export function FundAccountCard({
  nonprofit,
  className,
}: FundAccountCardProps) {
  return (
    <StyledCard className={className}>
      <p css={textSizeCss.m}>Want to support {nonprofit.name}?</p>
      <p>
        They haven’t created their profile yet. You can still support unclaimed
        nonprofits by opening a donor-advised fund with Every.org to recommend a
        grant to them.
      </p>
      <Button
        css={{ alignSelf: "flex-end" }}
        data-tname="fundAccountFromUnclaimedNonprofitPage"
        role={ButtonRole.SECONDARY}
        size={ButtonSize.MEDIUM}
        onClick={{
          kind: ButtonTargetKind.LINK,
          to: getRoutePath({
            name: ClientRouteName.MY_GIVING_PAYMENT,
            format: URLFormat.RELATIVE,
          }),
        }}
      >
        Open an Every.org DAF
      </Button>
    </StyledCard>
  );
}
